__turbopack_context__.v({
  "loader": "styles-module-scss-module__f1YAGW__loader",
  "noContent": "styles-module-scss-module__f1YAGW__noContent",
  "root": "styles-module-scss-module__f1YAGW__root",
});
